//import React from "react"
import { useSearchParams } from "react-router-dom"
/*import { Container } from "reactstrap"*/
import React, { useEffect, useState } from "react";
import { Loading } from "../../share/loading";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "../../share/form.css";
import Swal from "sweetalert2";
import DatePicker, { registerLocale } from "react-datepicker";
import th from 'date-fns/locale/th';
import { th as thBuddhist } from 'date-fns/esm/locale';
import { format } from 'date-fns';
import { addYears } from 'date-fns/esm/fp';
import 'react-datepicker/dist/react-datepicker.css'
import { Container, FormGroup, Label, Input } from "reactstrap";

export function InvoiceBorrowFormComponent () {
      const [searchParams] = useSearchParams();
    let borrowId = searchParams.get("req"); 
    const [loading, setLoading] = useState(true);
    const [foundValue, setFoundValue] = useState(true);
    const [data, setData] = useState([]);
    const user = JSON.parse(localStorage.getItem("userData"));

    useEffect(() => {
        async function getDataContact() {
            setLoading(true)
            let postData = new FormData();
            postData.append("borrowId", searchParams.get("req"))
            try {

                let res = await fetch(`api/Borrow/GetborrowOverdue`, {
                    method: "POST",
                    body: postData
                })
               
                let resJson = await res.json();

                resJson.dataenum.map(item => {
                    if (item.contactDate !== null) {
                        //setFoundValue(true)
                        setData(resJson.dataenum)
                    }
                })

            } catch (e) {
                // console.log("err =>", e)
            } finally {
                setLoading(false)
            }
        }
        getDataContact()

    }, [searchParams])

    const formInitialValues = {
        userName: user.fullName,
        borrowId: borrowId,
        OverdueDate: data[0]?.overdueDate ?? "",
        CalDate:  data[0]?.calDate ?? "",
        OverdueInstallment:  data[0]?.overdueInstallment ?? "",
        PaymentAmount:  data[0]?.paymentAmount ?? "",
        Amount:  data[0]?.amount ?? "",
        InterestAmount:  data[0]?.interestAmount ?? "",
        PaymentMenthod:  data[0]?.paymentMenthod ?? "",

       
    }

    const validateSchema = Yup.object().shape({
        OverdueDate: Yup.date(),
        CalDate: Yup.date(),
        OverdueInstallment: Yup.number().required("required"),
        PaymentAmount: Yup.number().required("required"),
        Amount: Yup.number().required("required"),
        InterestAmount: Yup.number().required("required"),
        PaymentMenthod: Yup.string(),
 
    })

    const renderCustomHeader = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
        const year = format(date, 'yyyy', { locale: th });
        return (
            <div className="react-datepicker__custom-header">
                <div className="react-datepicker__custom-header-left">
                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--previous"
                        aria-label="previous month"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
                    </button>
                </div>
                <div className="react-datepicker__custom-header-center">
                    {format(date, 'MMMM', { locale: th })} {Number(year) + 543}
                </div>
                <div className="react-datepicker__custom-header-right">
                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--next"
                        aria-label="next month"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
                    </button>
                </div>
            </div>
        );
    };


    const onSubmit = async (values) => {
        setLoading(true)
        try {
            let res = await fetch(`api/Borrow/saveborrowOverdue`, {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(values),
            })
            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    window.location.reload();
                })
            }
        } catch (e) {
            // console.log(e)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Formik
            initialValues={formInitialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ setFieldValue, errors, touched, values }) => {
                // console.log("values",values)
                // console.log("errors", errors)
                // console.log(errors)
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {loading ? (

                            <Loading />

                        ) : (
                            <div style={{ maxWidth: "850px", width: "100%" }} className="d-flex flex-column justify-content-center align-items-center w-100">
                                    <div className="d-flex justify-content w-100 mb-2">
                                        <button
                                            style={{ color: "#0A66C2" }}
                                            type="button"
                                            className={data.length > 0 ? "btn border border-1 mx-3" : "d-none"}
                                            onClick={() => {
                                                window.open(`api/ContactBorrow/geExprotword201/${borrowId}`, '_blank');
                                            }
                                            }
                                            download
                                        >
                                            แจ้งให้ชำระหนี้ สัญญากู้ยืมเงิน
                                        </button>
                                        <button
                                            style={{ color: "#0A66C2" }}
                                            type="button"
                                            className={data.length > 0 ? "btn border border-1 mx-3" : "d-none"}
                                            onClick={() => {
                                                window.open(`api/ContactBorrow/geExprotword202/${borrowId}`, '_blank');
                                            }
                                            }
                                            download
                                        >
                                            แจ้งให้ชำระหนี้ สัญญาค้ำประกัน
                                        </button>
                                        <button
                                            style={{ color: "#0A66C2" }}
                                            type="button"
                                            className={data.length > 0 ? "btn border border-1 mx-3" : "d-none"}
                                            onClick={() => {
                                                window.open(`api/ContactBorrow/geExprotword203/${borrowId}`, '_blank');
                                            }
                                            }
                                            download
                                        >
                                            บอกเลิกสัญญา สัญญากู้ยืมเงิน
                                        </button>
                                       
                                    </div>
                                    <div className="d-flex justify-content w-100 mb-2">
                                        <button
                                            style={{ color: "#0A66C2" }}
                                            type="button"
                                            className={data.length > 0 ? "btn border border-1 mx-3" : "d-none"}
                                            onClick={() => {
                                                window.open(`api/ContactBorrow/geExprotword204/${borrowId}`, '_blank');
                                            }
                                            }
                                            download
                                        >
                                            แจ้งให้ชำระหนี้ สัญญาค้ำประกัน
                                        </button>
                                        <button
                                            style={{ color: "#0A66C2" }}
                                            type="button"
                                            className={data.length > 0 ? "btn border border-1 mx-3" : "d-none"}
                                            onClick={() => {
                                                window.open(`api/ContactBorrow/geExprotword205/${borrowId}`, '_blank');
                                            }
                                            }
                                            download
                                        >
                                            แจ้งให้ชำระหนี้ สัญญาประนอมหนี้
                                        </button>
                                        <button
                                            style={{ color: "#0A66C2" }}
                                            className={data.length > 0 ? "btn border border-1 mx-3" : "d-none"}
                                            type="button"

                                            onClick={() => {
                                                // window.open(`api/ContactBorrow/geExprotword122/${borrowId}`,'_blank');
                                                window.open(`api/ContactBorrow/geExprotword206/${borrowId}`, '_blank');
                                            }
                                            }
                                            download
                                        >
                                            แจ้งให้ชำระหนี้ สัญญาค้ำประกันการประนอม
                                        </button>
                                    </div>
                                <div className="form-border">
                                    <Form autoComplete="off">
                                        <div className="p-5">

                                          

                                           

                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <Label className="w-50">ไม่ชำระหนี้เงินกู้ยืมตั้งแต่งวดที่<span className="require-input">*</span></Label>
                                                    <Field name="OverdueInstallment">
                                                        {({ field, meta }) => (
                                                            <Input
                                                                type="text"
                                                              
                                                                className={meta.touched && meta.error ?
                                                                    "input-error rounded-pill text-center input-color" :
                                                                    "rounded-pill text-center input-color"}
                                                                {...field}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <Label className="w-50">วันที่ผิดสัญญาทำสัญญา<span className="require-input">*</span></Label>
                                                    <Field name="OverdueDate">
                                                        {({ field, meta, form }) => {
                                                            const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                                            // console.log("select Data =>", selectedDate)
                                                            const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                                            const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                                            const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;


                                                            return (
                                                                <DatePicker
                                                                    selected={selectedDate}
                                                                    locale="th-buddhist"
                                                                    
                                                                    showIcon
                                                                    calendarClassName="thai-buddhist"
                                                                    dateFormat="dd MMMM yyyy"
                                                                    value={formattedDate}
                                                                    isClearable={true}
                                                                    placeholderText="กรุณาเลือก"
                                                                    renderCustomHeader={renderCustomHeader}
                                                                    onChange={(date) => {
                                                                        if (date instanceof Date && !isNaN(date)) {
                                                                            const isoDate = date.toISOString().substring(0, 10)
                                                                            form.setFieldValue(field.name, isoDate);
                                                                        } else {
                                                                            form.setFieldValue(field.name, "");
                                                                        }
                                                                    }}
                                                                    customInput={
                                                                        <Input
                                                                            type="text"
                                                                            className={
                                                                                touched.contactDate && errors.contactDate
                                                                                    ? "input-error rounded-pill text-center input-color"
                                                                                    : "rounded-pill text-center input-color"
                                                                            }
                                                                            value={formattedDate}
                                                                          /*  disabled={foundValue}*/
                                                                            onChange={() => { }}
                                                                            onBlur={field.onBlur}
                                                                        />
                                                                    }
                                                                />
                                                            )
                                                        }}
                                                    </Field>
                                                   
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <Label className="w-50">จำนวนเงินที่ค้างชำระ<span className="require-input">*</span></Label>
                                                    <Field name="PaymentAmount">
                                                        {({ field, meta }) => (
                                                            <Input
                                                                type="text"
                                                              /*  disabled={foundValue}*/
                                                                className={meta.touched && meta.error ?
                                                                    "input-error rounded-pill text-center input-color" :
                                                                    "rounded-pill text-center input-color"}
                                                                {...field}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <Label className="w-50">เงินต้นค้างชำระ<span className="require-input">*</span></Label>
                                                    <Field name="Amount">
                                                        {({ field, meta }) => (
                                                            <Input
                                                                type="text"
                                                                /*disabled={foundValue}*/
                                                                className={meta.touched && meta.error ?
                                                                    "input-error rounded-pill text-center input-color" :
                                                                    "rounded-pill text-center input-color"}
                                                                {...field}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <Label className="w-50">ดอกเบี้ย<span className="require-input">*</span></Label>
                                                    <Field name="InterestAmount">
                                                        {({ field, meta }) => (
                                                            <Input
                                                                type="text"
                                                               /* disabled={foundValue}*/
                                                                className={meta.touched && meta.error ?
                                                                    "input-error rounded-pill text-center input-color" :
                                                                    "rounded-pill text-center input-color"}
                                                                {...field}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <Label className="w-50">คำนวณถึงวันที่<span className="require-input">*</span></Label>
                                                    <Field name="CalDate">
                                                        {({ field, meta, form }) => {
                                                            const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                                            // console.log("select Data =>", selectedDate)
                                                            const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                                            const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                                            const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;


                                                            return (
                                                                <DatePicker
                                                                    selected={selectedDate}
                                                                    locale="th-buddhist"
                                                                    /*disabled={foundValue}*/
                                                                    showIcon
                                                                    calendarClassName="thai-buddhist"
                                                                    dateFormat="dd MMMM yyyy"
                                                                    value={formattedDate}
                                                                    isClearable={true}
                                                                    placeholderText="กรุณาเลือก"
                                                                    renderCustomHeader={renderCustomHeader}
                                                                    onChange={(date) => {
                                                                        if (date instanceof Date && !isNaN(date)) {
                                                                            const isoDate = date.toISOString().substring(0, 10)
                                                                            form.setFieldValue(field.name, isoDate);
                                                                        } else {
                                                                            form.setFieldValue(field.name, "");
                                                                        }
                                                                    }}
                                                                    customInput={
                                                                        <Input
                                                                            type="text"
                                                                            className={
                                                                                touched.contactDate && errors.contactDate
                                                                                    ? "input-error rounded-pill text-center input-color"
                                                                                    : "rounded-pill text-center input-color"
                                                                            }
                                                                            value={formattedDate}
                                                                           /* disabled={foundValue}*/
                                                                            onChange={() => { }}
                                                                            onBlur={field.onBlur}
                                                                        />
                                                                    }
                                                                />
                                                            )
                                                        }}
                                                    </Field>

                                                </div>
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <Label className="w-50">หรือชำระผ่านทาง</Label>
                                                    <Field name="PaymentMenthod">
                                                        {({ field, meta }) => (
                                                            <Input
                                                                type="text"
                                                                /*disabled={foundValue}*/
                                                                className={meta.touched && meta.error ?
                                                                    "input-error rounded-pill text-center input-color" :
                                                                    "rounded-pill text-center input-color"}
                                                                {...field}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>

                                            <FormGroup className="d-flex justify-content-center align-items-center">
                                                <button type="submit" className="btn-blue w-25">บันทึก</button>
                                            </FormGroup>
                                        </div>

                                    </Form>
                                </div>
                            </div>

                        )}

                    </Container>
                )

            }}
        </Formik>

    )
}